import React from 'react';
import PropTypes from 'prop-types';
import { Heading, LinkButton } from '../../atoms';
import { ResponsiveImage } from '../ResponsiveImage';
import {
  ButtonContainer,
  Subtext,
  TestimonialContainer,
  TestimonialsHighlightContainer,
} from './styles';

export const TestimonialHighlight = ({
  testimonial,
  image,
  buttonText,
  buttonTarget,
  backgroundColor,
}) => {
  return (
    <TestimonialsHighlightContainer backgroundColor={backgroundColor}>
      {image?.src && <ResponsiveImage {...image} />}
      <TestimonialContainer>
        <Heading
          headingLevel="h5"
          headingText={testimonial.body}
          position="center"
          typography="heading4"
        />
        <Subtext>{testimonial.name}</Subtext>
        <ButtonContainer>
          <LinkButton href={buttonTarget} horizontalPadding={10}>
            {buttonText}
          </LinkButton>
        </ButtonContainer>
      </TestimonialContainer>
    </TestimonialsHighlightContainer>
  );
};

TestimonialHighlight.displayName = 'TestimonialHighlight';

TestimonialHighlight.propTypes = {
  image: PropTypes.object,
  backgroundColor: PropTypes.string,
  buttonTarget: PropTypes.string.isRequired,
  testimonial: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
};
